<template>
  <div v-if="authenticated" id="account">

    <div v-if="user.role_id === 3 && !user.published" class="fast-signup">
      <b-container>
        <h2 class="mb-3">{{ $t('fastReg.title') }}</h2>
        <p>{{ $t('fastReg.description') }}</p>

        <div class="md-stepper-horizontal green">
          <div v-if="1 === 2"
               @click="changeStep(0)"
               class="md-step"
               :class="{ editable: step === 0, 'done active': step0Completed }">
            <div class="md-step-circle"><span>1</span></div>
            <div class="md-step-title">{{ $t('fastReg.step0.title') }}</div>
            <div class="md-step-bar-left"></div>
            <div class="md-step-bar-right"></div>
          </div>
          <div @click="changeStep(1)"
               class="md-step"
               :class="{ editable: step === 1, 'done active': step1Completed }">
            <div class="md-step-circle"><span>2</span></div>
            <div class="md-step-title">{{ $t('fastReg.step1.title') }}</div>
            <div class="md-step-bar-left"></div>
            <div class="md-step-bar-right"></div>
          </div>
          <div @click="changeStep(2)"
               class="md-step"
               :class="{ editable: step === 2, 'done active': step2Completed }">
            <div class="md-step-circle"><span>3</span></div>
            <div class="md-step-title">{{ $t('fastReg.step2.title') }}</div>
            <div class="md-step-bar-left"></div>
            <div class="md-step-bar-right"></div>
          </div>
          <div @click="changeStep(3)"
               class="md-step"
               :class="{ editable: step === 3, 'done active': step3Completed }">
            <div class="md-step-circle"><span>4</span></div>
            <div class="md-step-title">{{ $t('fastReg.step3.title') }}</div>
            <div class="md-step-bar-left"></div>
            <div class="md-step-bar-right"></div>
          </div>
          <div @click="changeStep(4)"
               class="md-step"
               :class="{ editable: step === 4, 'done active': step4Completed }">
            <div class="md-step-circle"><span>5</span></div>
            <div class="md-step-title">{{ $t('fastReg.step4.title') }}</div>
            <div class="md-step-bar-left"></div>
            <div class="md-step-bar-right"></div>
          </div>
        </div>

        <div id="fastreg-edit-block">
          <div v-if="step === 0">
            <pricing :fastReg="true" @success="membershipSelected"></pricing>
          </div>

          <div v-if="step === 1" class="wrapper" id="basic-info-block">
            <form action="#" @submit.prevent="finishStep1">
              <div style="max-width: 500px; margin: 0 auto;">
                <basic-info v-if="!_.isEmpty(user)"
                            ref="basicInfo"
                            @success="setBasicInfoSaved"
                            @basicInfoErrors="setBasicInfoErrors"
                            @setUserSpecialities="setUserSpecialities"
                            @openConfirmation="openConfirmation"
                            :data="user"
                            :loadedSpecialities="userSpecialities"
                            :fastReg="true"></basic-info>

                <preloader v-if="isStep1Loading" class="mb-5"></preloader>
                <p v-else class="mt-3" align="center">
                  <b-btn variant="primary"
                         :disabled="tempSpecialities.length === 0 || tempSpecialities.length > 5"
                         type="submit">{{ $t('fastReg.step1.finishBtn') }}</b-btn>
                </p>
              </div>
            </form>
          </div>

          <div v-if="step === 2 && step1Completed" id="locations-block">
            <form action="#" @submit.prevent="finishStep2" novalidate>
              <div style="max-width: 500px; margin: 0 auto;">
                <locations @locationsUnsaved="setLocationsUnsaved"
                           @setLocations="setLocations"
                           @success="setLocationsSaved"
                           :fastReg="true"
                           ref="locations" />

                <div class="mt-3">
                  <b-btn variant="secondary"
                         @click.prevent="prev()">{{ $t('buttons.previous') }}</b-btn>
                  <b-btn variant="primary"
                         :disabled="locations.length === 0"
                         type="submit">{{ $t('fastReg.step2.finishBtn') }}</b-btn>
                </div>
              </div>
            </form>
          </div>

          <div v-if="step === 3 && step1Completed && step2Completed" id="services-block">
            <form action="#" @submit.prevent="finishStep3" novalidate>
              <services :fastReg="true"
                        @prevStep="changeStep"
                        @nextStep="changeStep"
                        @success="setServicesSaved"
                        @justPublished="justPublished"></services>
            </form>
          </div>

          <div v-if="step === 4 && step1Completed && step2Completed && step3Completed" id="services-block">
            <form action="#" @submit.prevent="finishStep3" novalidate>
              <online-services :fastReg="true"
                               @prevStep="changeStep"
                               @success="setServicesSaved"
                               @justPublished="justPublished"></online-services>
            </form>
          </div>
        </div>

        <b-row v-if="!_.isEmpty(errors)" class="mt-3">
          <b-col>
            <response :items="errors"></response>
          </b-col>
        </b-row>
        <b-row v-if="1 === 2" class="mt-3">
          <b-col>
            <response text="Basic info and locations saved successfully!" variant="success"></response>
          </b-col>
        </b-row>

        <div>
          <a class="delete-account d-inline-flex" href="#" @click.prevent="deleteAccount()">
            <div>
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 511.999 511.999;" xml:space="preserve" width="24" height="24">
                        <circle style="fill:#E21B1B;" cx="255.999" cy="255.999" r="255.999"/>
                        <g>

                            <rect x="244.002" y="120.008" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -106.0397 256.0022)" style="fill:#FFFFFF;" width="24" height="271.988"/>

                            <rect x="120.008" y="244.007" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -106.0428 256.0035)" style="fill:#FFFFFF;" width="271.988" height="24"/>
                        </g>
                      </svg>
            </div>
            <div class="ml-1" style="margin-top: 0.2rem;">{{ $t('account.deleteAccount') }}</div>
          </a>
        </div>
      </b-container>
    </div>
    <div v-else>
      <section id="header-account" :class="{ customer: user.role_id === 2 }">
        <b-row v-if="user.role_id === 2" no-gutters>
          <b-col cols="12" md="6" class="offline-training">
            <div class="wrapper">
              <div class="text-center">
                <h2 class="text-center">{{ $t('findOfflineServices') }}</h2>
              </div>
              <b-btn class="btn-cta mt-2" variant="primary" :to="{ name: `ProfessionalsSearch.${$i18n.i18next.language}`, params: { search: '#', location: '#' } }">{{ $t('buttons.browseProfessionals') }}</b-btn>
            </div>
          </b-col>

          <b-col cols="12" md="6" class="online-training">
            <div class="wrapper">
              <div class="text-center">
                <h2 class="text-center">{{ $t('findOnlineServices') }}</h2>
              </div>
              <b-btn class="btn-cta mt-2" variant="primary" :to="{ name: `OnlineProfessionalsSearch.${$i18n.i18next.language}` }">{{ $t('buttons.browseProfessionals') }}</b-btn>
            </div>
          </b-col>
        </b-row>
        <div v-if="user.role_id === 3 && user.header_image && !headerPhotoDeleted" class="uploaded-header-image" :style="`background-image: url(${user.header_image})`">
          <div class="overlay"></div>
          <div class="buttons">
            <b-btn variant="secondary" @click.prevent="deleteHeaderPhoto()" class="clear-file">{{ $t('buttons.deleteChange') }}</b-btn>
            <b-btn v-if="1 === 2" variant="secondary" @click.prevent="deleteHeaderPhoto()" class="add-video">{{ $t('buttons.addVideo') }}</b-btn>
          </div>
        </div>
        <slim-cropper v-else-if="user.role_id === 3"
                      cropperId="cropper-header-image"
                      :options="slimHeaderOptions"
                      class="header-image">
          <input type="file"
                 name="header-image"
                 id="cropper-header-image"
                 accept="image/*" />
          <div v-if="1 === 2" class="video-input">
            <b-row>
              <b-col>
                <b-input-group>
                  <b-input-group-text slot="prepend">
                    <i class="material-icons">movie</i>
                  </b-input-group-text>
                  <b-form-input v-model="user.header_video"
                                type="text"
                                :maxlength="100"
                                :placeholder="$t('placeholders.headerVideo')"
                                v-b-tooltip.hover
                                :title="$t('titles.headerVideo')">
                  </b-form-input>
                  <b-input-group-append>
                    <b-btn variant="primary" @click="setHeaderVideo">{{ $t('buttons.save') }}</b-btn>
                    <b-btn v-if="user.header_video !== ''" variant="secondary" @click="deleteHeaderVideo">{{ $t('buttons.delete') }}</b-btn>
                  </b-input-group-append>
                </b-input-group>
                <div>
                  - or -
                </div>
              </b-col>
            </b-row>
          </div>
        </slim-cropper>
      </section>

      <b-container v-if="authenticated" class="mt-7">
        <b-row class="profile-header">
          <b-col cols="12" md="7" lg="6">
            <div class="profile-wrapper">
              <div class="profile-photo">
                <div v-if="user.image && !profilePhotoDeleted" class="uploaded-image">
                  <img :src="user.image" />
                  <b-btn variant="secondary" @click.prevent="deleteProfilePhoto()" class="clear-file">{{ $t('buttons.deleteChange') }}</b-btn>
                </div>
                <div v-else>
                  <slim-cropper :options="slimProfileOptions"
                                cropperId="cropper-profile-image"
                                class="dropzone">
                    <input type="file"
                           name="profile-image"
                           id="cropper-profile-image"
                           accept="image/*" />
                  </slim-cropper>
                </div>
              </div>
              <div class="user-name">
                <div class="d-block align-top">
                  <h1>{{ user.first_name }} {{ user.last_name }}</h1>
                </div>
                <div class="specialities d-block" v-if="!_.isEmpty(userSpecialities)">
                  <div class="font-italic" v-for="speciality in userSpecialities">
                    - {{ $t(`services.${speciality.name}`) }}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="user.role_id === 3" class="membership mt-3">
              <div class="label d-inline">{{ $t('membership.label') }}:</div>
              <div v-if="user.membership_id === 2" class="level d-inline">{{ $t('membership.basic') }} <b-btn variant="primary" @click="">{{ $t('buttons.manage') }}</b-btn></div>
              <div v-else-if="user.membership_id === 3" class="level d-inline">{{ $t('membership.premium') }}</div>
              <div v-else class="level d-inline">{{ $t('membership.free') }} <b-btn variant="primary" :to="{ name: `Pricing.${$i18n.i18next.language}` }">{{ $t('buttons.upgrade') }}</b-btn></div>
            </div>

            <div v-if="user.role_id === 3" class="mt-3 d-none d-md-block">
              <div v-if="isPostsLoading" class="white-block p-2 p-md-5">
                <preloader :title="$t('preloader.facebookPosts')"></preloader>
              </div>
              <div v-else-if="!_.isEmpty(posts)">
                <div v-if="!_.isEmpty(posts.analyzer)"
                     class="d-inline-block fb-score"
                     :class="{ low: posts.analyzer.score < 40, medium: posts.analyzer.score >= 40 && posts.analyzer.score < 70, high: posts.analyzer.score >= 70 }"
                     v-b-tooltip.hover
                     :title="$t('account.facebook.posts.analyzer.scoreTooltip')">
                  <span>{{ $t('account.facebook.posts.analyzer.scoreLabel') }}</span>
                  <div class="percent">{{ posts.analyzer.score }}%</div>
                </div>
                <b-btn class="btn-delete-posts d-inline-block"
                       v-b-tooltip.hover
                       :title="$t('account.facebook.posts.disconnectInfo')"
                       @click="deletePosts()">
                  <i class="material-icons">
                    link_off
                  </i>
                  {{ $t('account.facebook.posts.disconnectBtn') }}
                </b-btn>

              </div>
              <div v-else>
                <b-btn class="btn-posts connect" @click="connectPostsModal()">
                  <img class="d-inline-block" src="@/assets/images/logo-fb.svg" width="40" height="40" />
                  <div class="d-inline-block">{{ $t('account.facebook.posts.connectBtn') }}</div>
                </b-btn>
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="5" lg="6">
            <div v-if="user.role_id === 3" class="other-photos d-none d-md-block" :class="{ 'no-photos': _.isEmpty(photos) }" align="center">
              <div v-if="isInstagramLoading" class="white-block p-2 p-md-5">
                <preloader :title="$t('preloader.instagram')"></preloader>
              </div>
              <div v-else-if="!_.isEmpty(photos)">
                <div v-if="slicedPhotos.length > 0" class="d-none d-md-block">
                  <div v-for="(photo, index) in slicedPhotos"
                       :key="index"
                       class="photo d-inline-block">
                    <img :src="photo.small" height="70" width="auto" />
                  </div>
                </div>
                <div class="d-none d-md-block">{{ $t('account.instagram.photos.source') }}: <a :href="`https://www.instagram.com/${photos.user_name}`" target="_blank">instagram.com/{{ photos.user_name }}</a></div>
                <div class="buttons" align="center">
                  <div v-if="!_.isEmpty(photos.analyzer)"
                       class="d-inline-block insta-score"
                       :class="{ low: photos.analyzer.score < 40, medium: photos.analyzer.score >= 40 && photos.analyzer.score < 70, high: photos.analyzer.score >= 70 }"
                       v-b-tooltip.hover
                       :title="$t('account.instagram.photos.analyzer.scoreTooltip')">
                    <span v-html="$t('account.instagram.photos.analyzer.scoreLabel')"></span>
                    <div class="percent">{{ photos.analyzer.score }}%</div>
                  </div>
                  <b-btn class="btn-instagram d-inline-block" @click="refreshInstagram()">
                    <img class="d-inline-block" src="https://finefit.s3.eu-north-1.amazonaws.com/images/logo_instagram%402x.jpg" width="60" height="60" />
                    <div class="d-inline-block">{{ $t('account.instagram.photos.refreshBtn') }}</div>
                  </b-btn>
                  <b-btn class="btn-delete-instagram d-inline-block" @click="deleteInstagram()">
                    <i class="material-icons">
                      delete
                    </i>
                  </b-btn>
                </div>
              </div>
              <b-btn v-else class="btn-instagram connect" @click="connectInstagram()">
                <img class="d-inline-block" src="https://finefit.s3.eu-north-1.amazonaws.com/images/logo_instagram%402x.jpg" width="60" height="60" />
                <div class="d-inline-block">+ {{ $t('account.instagram.photos.connectBtn') }}</div>
              </b-btn>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <b-container v-if="authenticated">

        <b-tabs :lazy="true"
                pills
                card
                vertical
                v-model="activeTab">

          <b-btn v-if="showTabsMobile"
                 block
                 class="mobile-tab d-md-none"
                 @click="changeTab(`Account.${$i18n.i18next.language}`)"
                 variant="secondary">
            {{ $t('account.basicInfoTitle') }}
            <i class="material-icons">
              keyboard_arrow_right
            </i>
          </b-btn>

          <b-tab :title="$t('account.generalTitle')" disabled></b-tab>
          <b-tab :title="$t('account.basicInfoTitle')"
                 @click="changeTab(`Account.${$i18n.i18next.language}`)"
                 :class="{ 'd-none': !showTabsMobile, 'd-md-block': !showTabsMobile }"
                 class="info-area basic-info-area">
            <section class="basic-info info-block">
              <basic-info v-if="!_.isEmpty(user)"
                          @openConfirmation="openConfirmation"
                          class="info-comp"
                          :data="user"
                          :loadedSpecialities="userSpecialities"
                          ref="basicInfo"></basic-info>
            </section>
          </b-tab>

          <b-btn v-if="showTabsMobile && user.role_id === 3"
                 block
                 class="mobile-tab d-md-none"
                 @click="changeTab(`AccountCertificates.${$i18n.i18next.language}`)"
                 variant="secondary">
            {{ $t('buttons.certificates') }}
            <i class="material-icons">
              keyboard_arrow_right
            </i>
          </b-btn>
          <b-tab v-if="user.role_id === 3"
                 :title="$t('account.certificatesTitle')"
                 @click="changeTab(`AccountCertificates.${$i18n.i18next.language}`)"
                 class="info-area certificates-area">
            <section class="certificates info-block">
              <h2>{{ $t('account.certificatesDescription') }}</h2>
              <certificates class="info-comp"></certificates>
            </section>
          </b-tab>

          <b-btn v-if="showTabsMobile && user.role_id === 3"
                 block
                 class="mobile-tab d-md-none"
                 @click="changeTab(`AccountSocial.${$i18n.i18next.language}`)"
                 variant="secondary">
            {{ $t('account.socialTitle') }}
            <i class="material-icons">
              keyboard_arrow_right
            </i>
          </b-btn>
          <b-tab v-if="user.role_id === 3"
                 :title="$t('account.socialTitle')"
                 @click="changeTab(`AccountSocial.${$i18n.i18next.language}`)"
                 class="info-area social-area"
                 title-link-class="online">
            <section class="social">
              <h2 v-if="1 === 2">{{ $t('account.socialDescription') }}</h2>
              <div v-if="user.role_id === 3">

                <b-alert v-if="user.membership_id === 1" class=""
                         variant="warning"
                         show>
                  <div v-html="$t('membership.upgradeSocialActivities')"></div>
                </b-alert>

                <div v-if="isPostsLoading" class="white-block p-2 p-md-5">
                  <preloader :title="$t('preloader.facebookPosts')"></preloader>
                </div>
                <div v-else-if="!_.isEmpty(posts)">
                  <div v-if="!_.isEmpty(posts.analyzer)">
                    <h3 align="left">
                      <img src="~/assets/images/icon_success.svg" width="20" class="align-middle mb-2" />
                      You have connected with FB activities</h3>
                    <b-row>
                      <b-col cols="12" lg="6" class="text-left">
                        <p v-html="$t('account.facebook.posts.analyzer.completeDesc')"></p>

                        <b-btn class="btn-delete-posts d-block mt-3"
                               v-b-tooltip.hover
                               :title="$t('account.facebook.posts.disconnectInfo')"
                               @click="deletePosts()">
                          <i class="material-icons">
                            link_off
                          </i>
                          {{ $t('account.facebook.posts.disconnectBtn') }}
                        </b-btn>
                      </b-col>
                      <b-col cols="12" lg="6" align="center">
                        <div class="c100" :class="[ `p${posts.analyzer.score}`, { low: posts.analyzer.score < 40, medium: posts.analyzer.score >= 40 && posts.analyzer.score < 70, high: posts.analyzer.score >= 70 } ]">
                          <span>{{ posts.analyzer.score }}%</span>
                          <div class="slice">
                            <div class="bar"></div>
                            <div class="fill"></div>
                          </div>
                        </div>
                        <p v-html="$t('account.facebook.posts.analyzer.completeResult', { count: posts.analyzer.count })"></p>
                      </b-col>
                    </b-row>
                  </div>
                  <div v-else>
                    <h3>
                      <img src="~/assets/images/icon_success.svg" width="20" class="align-middle mb-2" />
                      You have connected with FB activities</h3>
                    <b-row>
                      <b-col cols="12" lg="6" class="text-left">
                        <p class="text-left">
                          You have connected with your Facebook activities, which help to get better exposure on search results, and allow your customers to follow your social media activities in one place.
                        </p>
                        <b-btn class="btn-delete-posts d-block mt-3 mx-auto mx-md-0"
                               v-b-tooltip.hover
                               :title="$t('account.facebook.posts.disconnectInfo')"
                               @click="deletePosts()">
                          <i class="material-icons">
                            link_off
                          </i>
                          {{ $t('account.facebook.posts.disconnectBtn') }}
                        </b-btn>
                      </b-col>
                      <b-col cols="12" lg="6" align="center">
                        <div class="c100 p70 high">
                          <span>--- %</span>
                          <div class="slice">
                            <div class="bar"></div>
                            <div class="fill"></div>
                          </div>
                        </div>
                        <p>How well you perform on FB?</p>
                        <b-btn class="btn-analyze-posts d-block mt-3"
                               @click="analyzePosts()">
                          <i class="material-icons">
                            autorenew
                          </i>
                          Analyze FB posts
                        </b-btn>
                      </b-col>
                    </b-row>
                  </div>
                </div>
                <div v-else>
                  <h3 align="left">
                    <img src="~/assets/images/icon_success_disabled.svg" width="20" class="align-middle mb-2" />
                    Connect with FB activities</h3>
                  <b-row>
                    <b-col cols="12" lg="6">
                      <p class="text-left">
                        Connect with your Facebook activities. They can increase your exposure in search results and your customers can follow your social activities in one place.
                      </p>
                    </b-col>
                    <b-col cols="12" lg="6" align="center">
                      <b-btn class="btn-posts connect" @click="connectPostsModal()">
                        <img class="d-inline-block" src="@/assets/images/logo-fb.svg" width="40" height="40" />
                        <div class="d-inline-block">{{ $t('account.facebook.posts.connectBtn') }}</div>
                      </b-btn>
                    </b-col>
                  </b-row>
                </div>
              </div>

              <div class="mt-5 other-photos">
                <div v-if="isInstagramLoading" class="white-block p-2 p-md-5">
                  <preloader :title="$t('preloader.instagram')"></preloader>
                </div>
                <div v-else-if="!_.isEmpty(photos)">
                  <div v-if="!_.isEmpty(photos.analyzer)">
                    <h3 align="left">
                      <img src="~/assets/images/icon_success.svg" width="20" class="align-middle mb-2" />
                      You have connected with Instagram photos</h3>
                    <b-row>
                      <b-col cols="12" lg="6" class="text-left">
                        <p v-html="$t('account.facebook.posts.analyzer.completeDesc')"></p>

                        <b-btn class="btn-delete-posts d-block mt-3 mx-auto mx-md-0"
                               v-b-tooltip.hover
                               :title="$t('account.instagram.photos.disconnectInfo')"
                               @click="deleteInstagram()">
                          <i class="material-icons">
                            link_off
                          </i>
                          {{ $t('account.instagram.photos.disconnectBtn') }}
                        </b-btn>
                      </b-col>
                      <b-col cols="12" lg="6" align="center">
                        <div class="c100" :class="[ `p${photos.analyzer.score}`, { low: photos.analyzer.score < 40, medium: photos.analyzer.score >= 40 && photos.analyzer.score < 70, high: photos.analyzer.score >= 70 } ]">
                          <span>{{ photos.analyzer.score }}%</span>
                          <div class="slice">
                            <div class="bar"></div>
                            <div class="fill"></div>
                          </div>
                        </div>
                        <p v-html="$t('account.facebook.posts.analyzer.completeResult', { count: photos.analyzer.count })"></p>
                      </b-col>
                    </b-row>
                  </div>
                  <div v-else>
                    <h3 align="left" class="align-middle">
                      <img src="~/assets/images/icon_success.svg" width="20" class="align-middle mb-2" />
                      You have connected with Instagram photos</h3>
                    <b-row>
                      <b-col cols="12" lg="6" class="text-left">
                        <p class="text-left">
                          You have connected with your Instagram photos, which help to get better exposure on search results, and allow your customers to follow your social media activities in one place.
                        </p>
                        <b-btn class="btn-delete-posts d-block mt-3"
                               v-b-tooltip.hover
                               :title="$t('account.instagram.photos.disconnectInfo')"
                               @click="deleteInstagram()">
                          <i class="material-icons">
                            link_off
                          </i>
                          {{ $t('account.instagram.photos.disconnectBtn') }}
                        </b-btn>
                      </b-col>
                      <b-col cols="12" lg="6" align="center">
                        <div class="c100 p70 high">
                          <span>--- %</span>
                          <div class="slice">
                            <div class="bar"></div>
                            <div class="fill"></div>
                          </div>
                        </div>
                        <p>How well you perform on Instagram?</p>
                        <b-btn class="btn-analyze-posts d-block mt-3"
                               @click="analyzePhotos()">
                          <i class="material-icons">
                            autorenew
                          </i>
                          Analyze Instagram photos
                        </b-btn>
                      </b-col>
                    </b-row>
                  </div>
                </div>

                <div v-else>
                  <h3 align="left">
                    <img src="~/assets/images/icon_success_disabled.svg" width="20" class="align-middle mb-2" />
                    Connect with Instagram photos
                  </h3>
                  <b-row>
                    <b-col cols="12" lg="6">
                      <p class="text-left">
                        Connect with your Instagram activities. They can increase your exposure in search results and your customers can follow your social activities in one place.
                      </p>
                    </b-col>
                    <b-col cols="12" lg="6" align="center">
                      <b-btn class="btn-instagram connect" @click="connectInstagram()">
                        <img class="d-inline-block" src="https://finefit.s3.eu-north-1.amazonaws.com/images/logo_instagram%402x.jpg" width="60" height="60" />
                        <div class="d-inline-block">+ {{ $t('account.instagram.photos.connectBtn') }}</div>
                      </b-btn>
                    </b-col>
                  </b-row>
                </div>
              </div>

            </section>
          </b-tab>

          <b-tab v-if="user.role_id === 3"
                 :title="$t('account.offlineTitle')" disabled></b-tab>
          <b-btn v-if="showTabsMobile && user.role_id === 3"
                 block
                 class="mobile-tab d-md-none"
                 @click="changeTab(`AccountLocations.${$i18n.i18next.language}`)"
                 variant="secondary">
            {{ $t('account.locationsTitle') }}
            <i class="material-icons">
              keyboard_arrow_right
            </i>
          </b-btn>

          <b-tab v-if="user.role_id === 3"
                 :title="$t('account.locationsTitle')"
                 @click="changeTab(`AccountLocations.${$i18n.i18next.language}`)"
                 class="info-area locations-area">
            <section class="locations info-block">
              <locations class="info-comp"
                         @locationsUnsaved="setLocationsUnsaved"
                         @success="setLocationsSaved"
                         @compareLocationsData="compareLocationsData"
                         ref="locations" />
              <b-button v-if="1 === 2" variant="secondary" @click="savePhotos">{{ $t('buttons.savePhotos') }}</b-button>

              <div class="unsaved-changes">
                <b-row v-if="unsavedChanges.locations" class="no-gutters">
                  <b-col cols="12">
                    <b-alert variant="warning" class="mb-0" show>
                      {{ $t('account.alerts.unsavedChanges', { var: 'Locations' }) }} <b-button variant="primary" @click="saveLocations">{{ $t('buttons.saveLocations') }}</b-button>
                    </b-alert>
                  </b-col>
                </b-row>
                <b-row v-if="!_.isEmpty(errors)">
                  <b-col>
                    <response :items="errors"></response>
                  </b-col>
                </b-row>
                <b-row v-if="locationsSuccess">
                  <b-col>
                    <response text="Locations saved successfully!" variant="success"></response>
                  </b-col>
                </b-row>
              </div>
            </section>
          </b-tab>

          <b-btn v-if="showTabsMobile && user.role_id === 3"
                 block
                 class="mobile-tab d-md-none"
                 @click="changeTab(`AccountServices.${$i18n.i18next.language}`)"
                 variant="secondary">
            {{ $t('account.servicesTitle') }}
            <i class="material-icons">
              keyboard_arrow_right
            </i>
          </b-btn>

          <b-tab v-if="user.role_id === 3"
                 :title="$t('account.servicesTitle')"
                 @click="changeTab(`AccountServices.${$i18n.i18next.language}`)"
                 class="info-area services-area">
            <section class="services">
              <h2 v-if="1 === 2">{{ $t('account.servicesDescription') }}</h2>
              <services></services>
            </section>
          </b-tab>

          <b-tab v-if="user.role_id === 3"
                 :title="$t('account.onlineTitle')"
                 disabled></b-tab>
          <b-btn v-if="showTabsMobile && user.role_id === 3"
                 block
                 class="mobile-tab d-md-none"
                 @click="changeTab(`AccountServicesOnline.${$i18n.i18next.language}`)"
                 variant="secondary">
            {{ $t('account.servicesOnlineTitle') }}
            <i class="material-icons">
              keyboard_arrow_right
            </i>
          </b-btn>

          <b-tab v-if="user.role_id === 3"
                 :title="$t('account.servicesOnlineTitle')"
                 @click="changeTab(`AccountServicesOnline.${$i18n.i18next.language}`)"
                 class="info-area services-area"
                 title-link-class="online">
            <section class="services">
              <online-services></online-services>
            </section>
          </b-tab>

          <b-btn v-if="showTabsMobile && user.role_id === 3"
                 block
                 class="mobile-tab d-md-none"
                 @click="changeTab(`AccountOnlineMaterials.${$i18n.i18next.language}`)"
                 variant="secondary">
            {{ $t('account.onlineMaterialsTitle') }}
            <i class="material-icons">
              keyboard_arrow_right
            </i>
          </b-btn>

          <b-tab v-if="user.role_id === 3"
                 :title="$t('account.onlineMaterialsTitle')"
                 @click="changeTab(`AccountOnlineMaterials.${$i18n.i18next.language}`)"
                 class="info-area certificates-area"
                 title-link-class="online">
            <section class="certificates info-block">
              <h2>{{ $t('account.onlineMaterialsDescription') }}</h2>
              <online-materials class="info-comp"></online-materials>
            </section>
          </b-tab>

          <b-tab title="System" disabled></b-tab>
          <b-btn v-if="showTabsMobile"
                 block
                 class="mobile-tab d-md-none"
                 @click="changeTab(`AccountSettings.${$i18n.i18next.language}`)"
                 variant="secondary">
            {{ $t('account.settingsTitle') }}
            <i class="material-icons">
              keyboard_arrow_right
            </i>
          </b-btn>

          <b-tab :title="$t('account.settingsTitle')"
                 @click="changeTab(`AccountSettings.${$i18n.i18next.language}`)"
                 class="info-area settings-area">
            <section class="settings">
              <h2>{{ $t('account.settingsDescription') }}</h2>
              <b-row v-if="user.role_id === 3">
                <b-col>
                  <user-membership></user-membership>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col class="text-center">
                  <a v-if="user.role_id === 3 && user.published" class="delete-account mr-3 d-inline-flex" href="#" @click.prevent="unpublishAccount()">
                    <div>
                      <span class="material-icons" style="margin-top: 0.1rem;">unpublished</span>
                    </div>
                    <div class="ml-1" style="margin-top: 0.2rem;">{{ $t('account.unpublishAccount') }}</div>
                  </a>

                  <a class="delete-account d-inline-flex" href="#" @click.prevent="deleteAccount()">
                    <div>
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 511.999 511.999;" xml:space="preserve" width="24" height="24">
                        <circle style="fill:#E21B1B;" cx="255.999" cy="255.999" r="255.999"/>
                        <g>

                            <rect x="244.002" y="120.008" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -106.0397 256.0022)" style="fill:#FFFFFF;" width="24" height="271.988"/>

                            <rect x="120.008" y="244.007" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -106.0428 256.0035)" style="fill:#FFFFFF;" width="271.988" height="24"/>
                        </g>
                      </svg>
                    </div>
                    <div class="ml-1" style="margin-top: 0.2rem;">{{ $t('account.deleteAccount') }}</div>
                  </a>
                </b-col>
              </b-row>
            </section>
          </b-tab>
        </b-tabs>
      </b-container>
    </div>

    <signed-up-modal></signed-up-modal>
    <confirmation :modalData="modalData" @success="confirmationSuccess"></confirmation>

    <b-modal id="analyzePostsModal" :title="$t('account.facebook.posts.analyzer.analyzerTitle')" v-model="analyzePostsModalShow">
      <div class="modal-body">
        <div v-if="isAnalyzerLoading" class="white-block p-2 p-md-5">
          <preloader :title="$t('preloader.analyzeFbPosts')"></preloader>
        </div>
        <div v-else-if="!_.isEmpty(analyzedPosts)">
          <h3>{{ $t('account.facebook.posts.analyzer.completeTitle') }}</h3>

          <p v-html="$t('account.facebook.posts.analyzer.completeDesc')"></p>

          <b-row>
            <b-col cols="12" sm="6">
              <div class="">
                <div class="c100" :class="[ `p${analyzedPosts.score}`, { low: analyzedPosts.score < 40, medium: analyzedPosts.score >= 40 && analyzedPosts.score < 70, high: analyzedPosts.score >= 70 } ]">
                  <span>{{ analyzedPosts.score }}%</span>
                  <div class="slice">
                    <div class="bar"></div>
                    <div class="fill"></div>
                  </div>
                </div>
                <div v-html="$t('account.facebook.posts.analyzer.completeResult', { count: analyzedPosts.count })"></div>
              </div>
            </b-col>
            <b-col cols="12" sm="6">
              <div class="mt-3">
                <div v-if="analyzedPosts.score < 40">
                  <p v-html="$t('account.facebook.posts.analyzer.low.intro')"></p>
                  <b-alert variant="info" show>
                    <p v-html="$t('account.facebook.posts.analyzer.low.info')"></p>
                  </b-alert>
                </div>
                <div v-else-if="analyzedPosts.score >= 40 && analyzedPosts.score < 70">
                  <p v-html="$t('account.facebook.posts.analyzer.medium.intro')"></p>
                  <b-alert variant="info" show>
                    <p v-html="$t('account.facebook.posts.analyzer.medium.info')"></p>
                  </b-alert>
                </div>
                <div v-else-if="analyzedPosts.score >= 70">
                  <p v-html="$t('account.facebook.posts.analyzer.high.intro')"></p>
                  <b-alert variant="info" show>
                    <p v-html="$t('account.facebook.posts.analyzer.medium.info')"></p>
                  </b-alert>
                </div>
              </div>

            </b-col>
          </b-row>
        </div>
      </div>
      <div slot="modal-footer"></div>
    </b-modal>

    <b-modal id="analyzePhotosModal" :title="$t('account.instagram.photos.analyzer.analyzerTitle')" v-model="analyzePhotosModalShow">
      <div class="modal-body">
        <div v-if="isAnalyzerLoading" class="white-block p-2 p-md-5">
          <preloader :title="$t('preloader.analyzeInstaPosts')"></preloader>
        </div>
        <div v-else-if="!_.isEmpty(analyzedPhotos)">
          <h3>{{ $t('account.instagram.photos.analyzer.completeTitle') }}</h3>

          <p v-html="$t('account.instagram.photos.analyzer.completeDesc')"></p>
          <b-row>
            <b-col cols="12" sm="6">
              <div class="">
                <div class="c100" :class="[ `p${analyzedPhotos.score}`, { low: analyzedPhotos.score < 40, medium: analyzedPhotos.score >= 40 && analyzedPhotos.score < 70, high: analyzedPosts.score >= 70 } ]">
                  <span>{{ analyzedPhotos.score }}%</span>
                  <div class="slice">
                    <div class="bar"></div>
                    <div class="fill"></div>
                  </div>
                </div>
                <div v-html="$t('account.instagram.photos.analyzer.completeResult', { count: analyzedPhotos.count })"></div>
              </div>
            </b-col>
            <b-col cols="12" sm="6">
              <div class="mt-3">
                <div v-if="analyzedPhotos.score < 40">
                  <p v-html="$t('account.instagram.photos.analyzer.low.intro')"></p>
                  <b-alert variant="info" show>
                    <p v-html="$t('account.instagram.photos.analyzer.low.info')"></p>
                  </b-alert>
                </div>
                <div v-else-if="analyzedPhotos.score >= 40 && analyzedPhotos.score < 70">
                  <p v-html="$t('account.instagram.photos.analyzer.medium.intro')"></p>
                  <b-alert variant="info" show>
                    <p v-html="$t('account.instagram.photos.analyzer.medium.info')"></p>
                  </b-alert>
                </div>
                <div v-else-if="analyzedPhotos.score >= 70">
                  <p v-html="$t('account.instagram.photos.analyzer.high.intro')"></p>
                  <b-alert variant="info" show>
                    <p v-html="$t('account.instagram.photos.analyzer.medium.info')"></p>
                  </b-alert>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <div slot="modal-footer"></div>
    </b-modal>

    <b-modal id="fbActivitiesModal" ref="fbActivitiesModal" :title="$t('account.facebook.posts.connectBtn')" :no-close-on-esc="true">
      <div class="modal-body">
        <div>
          <h3>{{ $t('account.facebook.posts.connectBtn') }}</h3>
          <p>{{ $t('account.facebook.posts.loadFrom') }}</p>
          <div class="row">
            <div class="col-sm-12 col-md-12">
              <b-btn class="btn-posts connect-pages" @click="connectPagePosts()" style="width: 100%;">
                <img height="24" src="@/assets/images/logo-fb-white.svg" />
                <div class="d-inline-block">{{ $t('account.facebook.posts.fbPagesBtn') }}</div>
              </b-btn>
            </div>
            <div class="col-sm-12 col-md-12 mt-3">
              <b-btn class="btn-posts connect-private" @click="connectPosts()" style="width: 100%;">
                <img height="24" src="@/assets/images/logo-fb.svg" />
                <div class="d-inline-block">{{ $t('account.facebook.posts.fbPrivateBtn') }}</div>
              </b-btn>
            </div>
          </div>
        </div>
      </div>
      <div slot="modal-footer" align="center">

      </div>
    </b-modal>

  </div>
  <div v-else>
    <b-alert variant="danger" show>
      {{ $t('account.accessDenied') }}
    </b-alert>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { frontEndDateFormat } from '@/util/date'

/* Start of lazy load components config */
import lazyLoadComponent from '@/util/lazy-load-component'
import Preloader from '@/app/global/components/Preloader'
// import SkeletonBox from '@/app/global/components/SkeletonBox'
const lazyLoadOptions = {
  loading: Preloader,
  loadingData: {
    props: {
      width: '100%',
      height: '2rem'
    }
  }
}
/* End of lazy load components config */

export default {
  name: 'Account',
  components: {
    Services: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./Services')}),
    OnlineServices: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./OnlineServices')}),
    OnlineMaterials: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./OnlineMaterials')}),
    Certificates: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./Certificates')}),
    BookingRequests: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./BookingRequests')}),
    Marketing: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./MarketingSelection')}),
    Messenger: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/messenger/components/Home')}),
    Multiselect: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('vue-multiselect')}),
    SlimCropper: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/global/components/slim-cropper/slim')}),
    BasicInfo: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./BasicInfo')}),
    Locations: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./Locations')}),
    SignedUpModal: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./JustSignedUpModal')}),
    ProfessionalCalendar: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./BookingsCalendar')}),
    CustomerCalendar: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./CustomerCalendar')}),
    Confirmation: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/global/components/Confirmation')}),
    Pricing: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./Pricing')}),
    UserMembership: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./Membership')})
  },
  data () {
    return {
      activeTab: 0,
      showTabsMobile: false,
      imgSrc: '',
      errors: [],
      basicSuccess: false,
      locationsSuccess: false,
      unsavedChanges: {
        basicInfo: false,
        locations: false,
        certificates: false
      },
      slimProfileOptions: {
        ratio: '1:1',
        minSize: {
          width: 200,
          height: 200
        },
        size: {
          width: 500,
          height: 500
        },
        uploadBase64: true,
        instantEdit: true,
        label: this.$i18n.t('image.dropLabel'),
        buttonConfirmLabel: this.$i18n.t('image.confirmLabel'),
        buttonConfirmTitle: this.$i18n.t('image.confirmTitle'),
        buttonCancelLabel: this.$i18n.t('image.cancelLabel'),
        buttonCancelTitle: this.$i18n.t('image.cancelTitle'),
        buttonEditTitle: this.$i18n.t('image.editTitle'),
        buttonRemoveTitle: this.$i18n.t('image.removeTitle'),
        buttonDownloadTitle: this.$i18n.t('image.downloadTitle'),
        buttonRotateTitle: this.$i18n.t('image.rotateTitle'),
        buttonUploadTitle: this.$i18n.t('image.uploadTitle'),
        statusImageTooSmall: this.$i18n.t('Drop your profile picture here'),
        didInit: this.slimInit,
        didConfirm: this.uploadProfilePhoto
      },
      slimHeaderOptions: {
        ratio: '3.14:1',
        minSize: {
          width: 800,
          height: 200
        },
        size: {
          width: 1100,
          height: 350
        },
        uploadBase64: true,
        instantEdit: true,
        label: this.$i18n.t('image.dropLabel'),
        buttonConfirmLabel: this.$i18n.t('image.confirmLabel'),
        buttonConfirmTitle: this.$i18n.t('image.confirmTitle'),
        buttonCancelLabel: this.$i18n.t('image.cancelLabel'),
        buttonCancelTitle: this.$i18n.t('image.cancelTitle'),
        buttonEditTitle: this.$i18n.t('image.editTitle'),
        buttonRemoveTitle: this.$i18n.t('image.removeTitle'),
        buttonDownloadTitle: this.$i18n.t('image.downloadTitle'),
        buttonRotateTitle: this.$i18n.t('image.rotateTitle'),
        buttonUploadTitle: this.$i18n.t('image.uploadTitle'),
        statusImageTooSmall: this.$i18n.t('Drop your profile picture here'),
        didInit: this.slimInit,
        didConfirm: this.uploadHeaderPhoto
      },
      certificate: {
        number: null,
        title: null,
        file: null
      },
      show: false,
      params: {
        token: '123456798',
        name: 'avatar'
      },
      headers: {
        smail: '*_~'
      },
      imgDataUrl: '',
      modalData: {
        title: 'modals.deleteProfile.confirmation.title',
        intro: 'modals.deleteProfile.confirmation.intro',
        successTitle: 'modals.deleteProfile.deleted.title',
        successIntro: 'modals.deleteProfile.deleted.intro',
        parameters: {
          id: null,
          action: 'auth/deleteSelf',
          endpoint: '/v1/profile'
        }
      },
      step: 1,
      step0Completed: false,
      step1Completed: false,
      step2Completed: false,
      step3Completed: false,
      step4Completed: false,
      isStep1Loading: false,
      isInstagramLoading: false,
      isPostsLoading: false,
      analyzePostsModalShow: false,
      analyzePhotosModalShow: false,
      isAnalyzerLoading: true,
      locations: [],
      locationsData: [],
      userBasicData: {},
      password: '',
      tempSpecialities: [],
      profilePhotoDeleted: false,
      headerPhotoDeleted: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'account/user',
      authenticated: 'account/authenticated',
      userSpecialities: 'account/userSpecialities',
      userLocations: 'account/userLocations',
      photos: 'account/userPhotos',
      analyzedPhotos: 'account/userAnalyzePhotos',
      posts: 'account/userPosts',
      analyzedPosts: 'account/userAnalyzePosts',
      userFollowings: 'account/userFollowings',
      unsaved: 'unsavedChanges'
    }),
    slicedPhotos: function () {
      if (!_.isEmpty(this.photos)) {
        if (this.photos.photos.length > 0) {
          return this.photos.photos.slice(0, 8)
        }
      }
      return []
    },
    activeTabComp: function () {
      if (!_.isNull(this.activeTab)) {
        return this.activeTab
      }
      return 0
    },
    userComp () {
      return this.user
    }
  },
  methods: {
    ...mapActions({
      getUserSpecialities: 'account/getUserSpecialities',
      saveUserSpecialities: 'account/saveUserSpecialities',
      connectInstagramPhotos: 'account/connectUserInstagramPhotos',
      refreshInstagramPhotos: 'account/refreshUserInstagramPhotos',
      getUserPhotos: 'account/getUserPhotos',
      analyzeUserPhotos: 'account/analyzeUserPhotos',
      connectFbPosts: 'account/connectUserFbPosts',
      connectFbPagePosts: 'account/connectPageFbPosts',
      getUserPosts: 'account/getUserPosts',
      analyzeUserPosts: 'account/analyzeUserPosts',
      getFollowings: 'account/getFollowings'
    }),
    ...mapMutations({
      setPublished: 'account/SET_USER_PUBLISHED'
    }),
    frontEndDateFormat: frontEndDateFormat,
    justPublished () {
      let target = document.getElementById('account')
      this.scrollToSmoothly(target.offsetTop, 300)
      this.$root.$emit('bv::show::modal', 'signedUpModal')
    },
    prev() {
      this.step--
    },
    next() {
      this.step++
    },
    changeStep(step) {
      // if (step === 1 && !this.step0Completed) {
      if (step === 2 && !this.step1Completed) {

      } else if (step === 3 && (!this.step1Completed || !this.step2Completed)) {

      } else if (step === 4 && (!this.step1Completed || !this.step2Completed || !this.step3Completed)) {
        this.scrollToFastRegTop()
      } else {
        this.step = step
      }
    },
    submit() {

    },
    slimInit (data, slim) {
      // slim instance reference
    },
    uploadProfilePhoto (data, slim) {
      let photoType = slim.dataBase64.output.type
      let base64 = slim.dataBase64.output.image
      base64 = base64.split(',')[1]

      // this.user.image = slim.dataBase64.output.image
      this.$refs.basicInfo.setProfilePhoto(slim.dataBase64.output.image)
    },
    uploadHeaderPhoto (data, slim) {
      let photoType = slim.dataBase64.output.type
      let base64 = slim.dataBase64.output.image
      base64 = base64.split(',')[1]

      // this.user.header_image = slim.dataBase64.output.image
      this.$refs.basicInfo.setHeaderPhoto(slim.dataBase64.output.image)

      // let uploadTask =  storageRef.child(`uploads/${user.uid}/header`)
      // let thumbHeader = storageRef.child(`uploads/${user.uid}/thumb_header`)
      //
      // uploadTask.putString(base64, 'base64', metadata).then(function (snapshot) {
      //   // let fullPath = `${snapshot.metadata.bucket}/${snapshot.metadata.fullPath}`
      //   uploadTask.getDownloadURL().then(function(downloadURL) {
      //     parent.saveUserHeaderPhoto({ payload: downloadURL, context: parent })
      //   })
      // })
    },
    unpublishAccount () {
      this.modalData = {
        title: 'modals.unpublishProfile.confirmation.title',
        intro: 'modals.unpublishProfile.confirmation.intro',
        successTitle: 'modals.unpublishProfile.unpublished.title',
        successIntro: 'modals.unpublishProfile.unpublished.intro',
        parameters: {
          id: null,
          action: 'account/unPublish',
          endpoint: '/v1/professional/me/unpublish'
        }
      }

      this.$root.$emit('bv::show::modal', 'confirmationModal')
    },
    deleteAccount () {
      this.modalData = {
        title: 'modals.deleteProfile.confirmation.title',
        intro: 'modals.deleteProfile.confirmation.intro',
        successTitle: 'modals.deleteProfile.deleted.title',
        successIntro: 'modals.deleteProfile.deleted.intro',
        parameters: {
          id: null,
          action: 'auth/deleteSelf',
          endpoint: '/v1/profile'
        }
      }

      this.$root.$emit('bv::show::modal', 'confirmationModal')
    },
    deleteProfilePhoto () {
      // this.user.image = null
      this.profilePhotoDeleted = true
      this.$refs.basicInfo.setProfilePhoto(null)
      // this.deleteUserProfilePhoto({context: parent})
    },
    deleteHeaderPhoto () {
      // this.user.header_image = null
      this.headerPhotoDeleted = true
      this.$refs.basicInfo.setHeaderPhoto(null)
      // this.deleteUserHeaderPhoto({context: parent})
    },
    setHeaderVideo () {
      let youtubeVideo = this.user.header_video

      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
      var match = youtubeVideo.match(regExp)
      let videoId = (match&&match[7].length==11) ? match[7] : youtubeVideo

      // this.user.header_video = videoId
      this.$refs.basicInfo.setHeaderVideo(videoId)
      // this.saveUserHeaderVideo({ payload: video, context: this })
    },
    deleteHeaderVideo () {
      // this.user.header_video = ''
      this.$refs.basicInfo.setHeaderVideo('')
      // this.deleteUserHeaderVideo({ context: this })
    },
    slimService (formdata, progress, success, failure, slim) {
      // slim instance reference
    },
    imageuploading(data) {
      console.log(data)
    },
    imageuploaded (res) {
      if (res.errcode == 0) {
        this.imgSrc = res.data.src
      }
    },
    membershipSelected () {
      this.step0Completed = true
      this.changeStep(1)
    },
    saveLocations () {
      this.$refs.locations.saveLocations()
    },
    saveBasicInfo () {
      this.$refs.basicInfo.saveBasicInfo(false, this.password)
    },
    compareBasicData (val) {
      // Create a non-reactive copy of user data to compare for unsaved changes.
      // this.userBasicData = val
      //
      // if (!_.isEqual(this.user, this.userBasicData)) {
      //   this.setUnsaved('basicInfo')
      // } else {
      //   this.unsavedChanges.basicInfo = false
      // }
    },
    compareLocationsData (val) {
      // Create a non-reactive copy of user data to compare for unsaved changes.
      this.locationsData = val

      if (!_.isEqual(this.userLocations, this.locationsData)) {
        this.setUnsaved('locations')
      } else {
        this.unsavedChanges.locations = false
      }
    },
    setSlug () {
      this.user.slug = _.toLower(this.user.slug)
      this.user.slug = this.user.slug.replace(/\s/g, '')
      this.setUnsaved('basicInfo')
    },
    setUnsaved (tab) {
      switch (tab) {
        case 'basicInfo':
          this.unsavedChanges.basicInfo = true
          this.basicSuccess = false
          break
        case 'locations':
          this.unsavedChanges.locations = true
          this.locationsSuccess = false
          break
      }
    },
    setBasicInfoUnsaved (value) {
      if (value) {
        this.setUnsaved('basicInfo')
      } else {
        this.unsavedChanges.basicInfo = false
      }
    },
    setBasicInfoErrors (errors) {
      this.errors = errors
      this.isStep1Loading = false
    },
    setBasicInfoSaved (value) {
      this.unsavedChanges.basicInfo = false
      this.step = 2
      this.step1Completed = true
      this.errors = []
      this.basicSuccess = true
      this.isStep1Loading = false
    },
    setLocationsUnsaved (value) {
      if (value) {
        this.setUnsaved('locations')
      } else {
        this.unsavedChanges.locations = false
      }
    },
    setLocationsSaved (value) {
      this.unsavedChanges.locations = false
      this.step = 3
      this.step2Completed = true
    },
    setServicesSaved (value) {
      this.unsavedChanges.services = false
      this.step = 4
      this.step3Completed = true
    },
    setLocations (value) {
      if (value) {
        this.locations = value
      }
    },
    setUserSpecialities (value) {
      if (value) {
        this.tempSpecialities = value
      }
    },
    openConfirmation (modalData) {
      this.modalData = modalData
      this.$root.$emit('bv::show::modal', 'confirmationModal')
    },
    toggleShow () {
      this.show = !this.show;
    },
    finishStep1 () {
      this.isStep1Loading = true
      this.$refs.basicInfo.saveBasicInfo(true)
    },
    finishStep2 () {
      this.saveLocations()
    },
    finishStep3 () {
      this.$refs.services.saveServices()
    },
    clearPassword () {
      this.password = ''
    },
    scrollToFastRegTop () {
      let target = document.getElementById('fastreg-edit-block')
      // this.animate(document, 'scrollTop', '', 0, target.offsetTop, 300, true)
      this.scrollToSmoothly(target.offsetTop, 300)
    },
    scrollToSmoothly (pos, time) {
      if (typeof pos !== 'number') {
        pos = parseFloat(pos)
      }
      if (isNaN(pos)) {
        console.warn('Position must be a number or a numeric String.')
        throw 'Position must be a number'
      }
      if (pos<0||time<0) {
        return
      }
      var currentPos = window.scrollY || window.screenTop;
      var start = null
      time = time || 500
      window.requestAnimationFrame(function step(currentTime) {
        start = !start? currentTime: start
        if (currentPos<pos) {
          var progress = currentTime - start
          window.scrollTo(0, ((pos-currentPos)*progress/time)+currentPos)
          if(progress < time) {
            window.requestAnimationFrame(step)
          } else {
            window.scrollTo(0, pos)
          }
        } else {
          var progress = currentTime - start
          window.scrollTo(0, currentPos-((currentPos-pos)*progress/time))
          if (progress < time) {
            window.requestAnimationFrame(step)
          } else {
            window.scrollTo(0, pos)
          }
        }
      })
    },
    animate (elem, style, unit, from, to, time, prop) {
      if (!elem) {
        return;
      }
      var start = new Date().getTime(),
        timer = setInterval(function () {
          var step = Math.min(1, (new Date().getTime() - start) / time)
          if (prop) {
            elem[style] = (from + step * (to - from))+unit
          } else {
            elem.style[style] = (from + step * (to - from))+unit
          }
          if (step === 1) {
            clearInterval(timer);
          }
        }, 25);
      if (prop) {
        elem[style] = from+unit
      } else {
        elem.style[style] = from+unit
      }
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess (imgDataUrl, field) {
      console.log('-------- crop success --------');
      this.imgDataUrl = imgDataUrl;
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess (jsonData, field) {
      console.log('-------- upload success --------');
      console.log(jsonData);
      console.log('field: ' + field);
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail (status, field) {
      console.log('-------- upload fail --------');
      console.log(status);
      console.log('field: ' + field);
    },
    openMessenger () {
      this.$root.$emit('bv::show::modal','messengerModal')
    },
    connectInstagram: function () {
      this.isInstagramLoading = true
      this.errors = []

      let payload = {
        lang: this.$i18n.i18next.language
      }
      this.connectInstagramPhotos({ context: this, payload: payload })
    },
    refreshInstagram: function () {
      this.isInstagramLoading = true
      this.errors = []

      let payload = {
        lang: this.$i18n.i18next.language
      }
      this.refreshInstagramPhotos({ context: this, payload: payload })
    },
    deleteInstagram () {
      this.modalData = {
        title: 'modals.deleteInstagram.confirmation.title',
          intro: 'modals.deleteInstagram.confirmation.intro',
          successTitle: 'modals.deleteInstagram.deleted.title',
          successIntro: 'modals.deleteInstagram.deleted.intro',
          parameters: {
          id: null,
            action: 'account/deletePhotos',
            endpoint: '/v1/professional/me/photos'
        }
      }

      this.$root.$emit('bv::show::modal', 'confirmationModal')
    },
    connectPostsModal () {
      this.$root.$emit('bv::show::modal', 'fbActivitiesModal')
    },
    connectPosts () {
      this.$root.$emit('bv::hide::modal', 'fbActivitiesModal')
      this.isPostsLoading = true
      this.errors = []

      let payload = {
        lang: this.$i18n.i18next.language
      }
      this.connectFbPosts({ context: this, payload: payload })
    },
    connectPagePosts () {
      this.$root.$emit('bv::hide::modal', 'fbActivitiesModal')
      this.isPostsLoading = true
      this.errors = []

      let payload = {
        lang: this.$i18n.i18next.language
      }
      this.connectFbPagePosts({ context: this, payload: payload })
    },
    loadingPosts () {
      this.isPostsLoading = true
      this.errors = []
    },
    deletePosts () {
      this.modalData = {
        title: 'modals.deletePosts.confirmation.title',
        intro: 'modals.deletePosts.confirmation.intro',
        successTitle: 'modals.deletePosts.deleted.title',
        successIntro: 'modals.deletePosts.deleted.intro',
        parameters: {
          id: null,
          action: 'account/deletePosts',
          endpoint: '/v1/professional/me/posts'
        }
      }

      this.$root.$emit('bv::show::modal', 'confirmationModal')
    },
    getUserFollowings () {
      this.getFollowings({ context: this })
    },
    changeTab (routerName) {
      this.$router.push({name: routerName})
      if (!this.unsaved) {
        this.tabsInit(routerName)
      }
    },
    disselectTab () {
      this.showTabsMobile = true
    },
    tabsInit (routerName) {
      this.showTabsMobile = true
      let parent = this
      switch (routerName) {
        case `Account.${this.$i18n.i18next.language}`:
          this.activeTab = 1
          break
        case `AccountCertificates.${this.$i18n.i18next.language}`:
          this.activeTab = 2
          break
        case `AccountSocial.${this.$i18n.i18next.language}`:
          this.activeTab = 3
          break
        case `AccountLocations.${this.$i18n.i18next.language}`:
          this.activeTab = 5
          break
        case `AccountServices.${this.$i18n.i18next.language}`:
          this.activeTab = 6
          break
        case `AccountServicesOnline.${this.$i18n.i18next.language}`:
          this.activeTab = 8
          break
        case `AccountOnlineMaterials.${this.$i18n.i18next.language}`:
          this.activeTab = 9
          break
        case `AccountSettings.${this.$i18n.i18next.language}`:
          this.activeTab = 11
          break
      }
    },
    analyzePosts () {
      this.isAnalyzerLoading = true
      this.analyzePostsModalShow = true
      let payload = {
        lang: this.$i18n.i18next.language
      }
      this.analyzeUserPosts({ context: this, payload: payload })
    },
    analyzePhotos () {
      this.isAnalyzerLoading = true
      this.analyzePhotosModalShow = true
      let payload = {
        lang: this.$i18n.i18next.language
      }
      this.analyzeUserPhotos({ context: this, payload: payload })
    },
    confirmationSuccess () {
      if (this.modalData.parameters.action === 'account/unPublish') {
        this.setPublished(false)
      }
    }
  },
  created () {
    this.tabsInit(this.$route.name)
  },
  mounted () {
    // If customer has just signed up - show welcome modal
    if (this.user.role_id === 2) {
      if (!_.isEmpty(this.$route.params) && !_.isUndefined(this.$route.params.justSignedUp)) {
        let signedUp = this.$route.params.justSignedUp
        if (signedUp) {
          this.justPublished()
        }
      }
    }

    if (this.user.role_id === 3) {
      if (!this.user.published) {
        // this.$root.$emit('bv::show::modal', 'signedUpModal')
        // this.$refs.signedUpModal.show()
      }

      if (!this.user.published && this.user.membership_id > 1) {
        this.step0Completed = true
        this.changeStep(1)
      }
    }

    // alert('mounted')
    // let parent = this
    // switch (this.$route.name) {
    //   case `Account.${this.$i18n.i18next.language}`:
    //     alert('0')
    //     parent.activeTab = 0
    //     break
    //   case `AccountLocations.${this.$i18n.i18next.language}`:
    //     alert('1')
    //     parent.activeTab = 1
    //     break
    //   case `AccountServices.${this.$i18n.i18next.language}`:
    //     alert('2')
    //     parent.activeTab = 2
    //     alert(this.activeTabComp)
    //     break
    //   case `AccountCertificates.${this.$i18n.i18next.language}`:
    //     alert('3')
    //     parent.activeTab = 3
    //     break
    //   case `AccountSocial.${this.$i18n.i18next.language}`:
    //     alert('4')
    //     parent.activeTab = 4
    //     break
    //   case `AccountSettings.${this.$i18n.i18next.language}`:
    //     alert('5')
    //     parent.activeTab = 5
    //     break
    // }

    this.getFollowings({ context: this })
    // this.getUserSpecialities({ context: this })

    this.getUserPhotos({ context: this }).then((response) => {
      // Instagram captions analyzer
      if ('instacheck' in this.$route.query) {
        if (this.$route.query.instacheck === 'true') {
          this.isAnalyzerLoading = true
          this.analyzePhotosModalShow = true
          // Analyze phoyos
          let payload = {
            lang: this.$i18n.i18next.language
          }
          this.analyzeUserPhotos({ context: this, payload: payload })
        }
      }
    }).catch((error) => {
      // Nothing
    })

    this.getUserPosts({ context: this }).then((response) => {
      // Facebook posts analyzer
      if ('fbposts' in this.$route.query) {
        if (this.$route.query.fbposts === 'true') {
          this.isAnalyzerLoading = true
          this.analyzePostsModalShow = true
          // Analyze posts
          let payload = {
            lang: this.$i18n.i18next.language
          }
          this.analyzeUserPosts({ context: this, payload: payload })
        }
      }
    }).catch((error) => {
      // Nothing
    })
  },
  watch: {
    // userLoadedSpecialities: function (newVal, oldVal) {
    //   this.userSpecialities = this.userLoadedSpecialities
    // },
    '$route' () {
      this.tabsInit(this.$route.name)
    },
    step () {
      this.scrollToFastRegTop()
    },
    userSpecialities () {
      this.tempSpecialities = this.userSpecialities
    },
    user: {
      deep: true,
      handler () {
        if (!this.user.published && this.user.membership_id > 1) {
          this.step0Completed = true
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import '~assets/styles/app.scss';

  #account {
    // -webkit-transform: translate3d(0,0,0); // Safari fixed position fix

    .modal-dialog {
      max-width: 700px;

      .sub-title {
        font-weight: bold;
        text-transform: uppercase;
      }
    }

    .slim {
      height: 100%;
    }

    #header-account {
      position: relative;
      min-height: 350px;
      background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(https://finefit.s3.eu-north-1.amazonaws.com/images/header_placeholder.jpg) no-repeat center center;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
      padding: 0;

      &.customer {
        background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(https://finefit.s3.eu-north-1.amazonaws.com/images/hero_home_new.jpg) no-repeat center center;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        overflow: visible;

        h1, h2 {
          color: white;
          font-size: 2rem;
          font-weight: bold;
          text-align: left;
          margin-bottom: 1rem;
        }

        .offline-training {
          margin-top: 2rem;
          @include media-breakpoint-down(sm) {
            padding: 1rem;
            margin-top: 0;
            background: url(https://finefit.s3.eu-north-1.amazonaws.com/images/hero_home_offline.jpg) no-repeat center center;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            overflow: visible;
          }
        }

        .online-training {
          margin-top: 2rem;

          .btn-cta {
            background-color: #6ecdff !important;
          }

          @include media-breakpoint-down(sm) {
            padding: 1rem;
            margin-top: 0;
            background: url(https://finefit.s3.eu-north-1.amazonaws.com/images/hero_home_online.jpg) no-repeat center center;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            overflow: visible;
          }
        }

        @include media-breakpoint-down(sm) {
          background: transparent;
          min-height: 500px;

          h2 {
            margin: 2rem 0;
            margin-bottom: 1rem;
          }

          .btn-cta {
            margin-bottom: 2rem;
          }
        }
      }

      .browse-professionals {
        margin-top: 10rem;
      }

      .uploaded-header-image {
        position: absolute;
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center center;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;

        .overlay {
          position: absolute;
          width: 100%;
          height: 100%;
          background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
        }

        .buttons{
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: 2;
        }
      }

      .header-image {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 0;

        .slim-file-hopper {
          background: rgba(0,0,0,.04);
        }

        .video-input {
          position: absolute;
          top: 30%;
          width: 100%;
          z-index: 4;

          .row {
            margin: 0;
            max-wdith: 300px;

            .input-group {
              max-width: 400px;
              margin: 0 auto;
            }
          }

          @include media-breakpoint-down(sm) {

          }
        }
      }

      .container {
        position: relative;
        height: 350px;
      }

      @include media-breakpoint-down(sm) {

      }
    }

    .profile-header {
      margin-bottom: 3rem;
    }
    .profile-wrapper {
      display: flex;
      width: auto;
      margin-top: -7rem;
      background: white;

      .profile-photo {
        display: inline-flex;
        vertical-align: top;
        max-height: 200px;

        .uploaded-image {
          position: relative;
          min-width: 200px;

          img {
            width: 200px;
            height: auto;
          }

          .btn {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }

          &:hover {
            opacity: .8;
            transition: all .7s;
          }
        }

        @include media-breakpoint-down(md) {
          max-height: 150px;

          .uploaded-image {
            img {
              width: 100%;
              height: auto;
            }
          }
        }

        @include media-breakpoint-down(sm) {
          max-height: 200px;
        }

        @include media-breakpoint-down(xs) {
          display: block;
          max-height: 100%;
        }
      }
      .user-name {
        display: inline-block;
        background: white;
        padding: 1rem;
        text-align: left;
        word-break: break-all;
        max-width: 300px;
        vertical-align: bottom;

        h1 {
          display: block;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          color: black;
          font-size: 1.5rem;
          font-weight: normal;
          text-align: left;
          margin: 0;

          @include media-breakpoint-down(sm) {
            font-size: 1.2rem;
          }
        }

        .specialities {
          font-size: 80%;
        }

        @include media-breakpoint-down(sm) {
          display: block;
          width: 100%;
          font-size: 0.8rem;
        }
      }

      @include media-breakpoint-down(sm) {
        .dropzone {

        }
      }

      @include media-breakpoint-down(xs) {
        display: block;
        margin: 0 auto;
        margin-top: -7rem;
        transform: unset;
        max-width: 300px;

        .dropzone {
          width: 300px;
          height: 300px;
        }
      }
    }

    .membership {
      .label {

      }
      .level {
        font-weight: bold;
      }
    }

    .dropzone {
      display: block;
      width: 200px;
      height: 100%;
      padding: 0;
      border: none;

      .dz-preview {
        margin: 0;
      }

      .dz-message {
        /*display: table-cell;*/
        /*vertical-align: middle;*/
      }
    }

    .btn.save-profile-photo {
      margin: 1.5rem;
    }

    .tabs {
      .col-auto {
        @include media-breakpoint-down(sm) {
          display: none;
        }
      }
    }

    .nav-pills {
      min-width: 200px;

      li.nav-item {
        a.nav-link {
          color: #2c3e50;

          &.active {
            color: white;
            background: #f1a444;

            &.online {
              background: #2e9bf1;
            }
          }

          &.disabled {
            font-weight: bold;
            border-bottom: 2px solid black;
            opacity: 0.3;
          }
        }
      }
    }

    .btn.mobile-tab {
      display: inline-block;
      color: black !important;
      font-weight: bold;
      white-space: normal;
      padding: 0.7rem 0.5rem;
      border: none;
      border-bottom: 2px solid black;
      border-radius: 0;
      text-align: left;
      box-shadow: none;
      background: transparent;

      i {
        margin-top: -3px;
        vertical-align: middle;
      }
    }

    .btn-back {
      position: relative;
      white-space: normal;

      i {
        position: absolute;
        left: 0.2rem;
        top: 50%;
        transform: translateY(-50%);
        margin-left: 0;
        margin-right: 0;
      }

      span {
        padding-left: 0.7rem;
        font-size: 0.8rem;
      }
    }

    .basic-info,
    .change-password-block {
      label {
        display: block;
        text-align: left;
        font-size: 0.8rem;
        font-weight: bold;
        margin-bottom: 0;
      }
      .form-control,
      .multiselect {
        margin: 1rem 0;
      }
    }

    ul.nav-tabs {
      margin-bottom: 1.5rem;

      li:first-child {
        margin-left: 0;
      }

      li.nav-item {
        a.nav-link {
          color: black;

          &.active {
            border: none;
            border-bottom: 2px solid black;
          }
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
  @import '~assets/styles/app.scss';

 /*.info-area {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 500px;
    overflow: hidden;
    transform: translateX(0);
    -webkit-transform: translateX(0);

    &.basic-info-area {
      min-height: 800px;
    }

    section.info-block {
      position: absolute;
      top: 0;
      z-index: 9;
      width: 100%;
      height: 100%;
      min-height: 100%;
      overflow-y: scroll;
    }
  }*/

  .unsaved-changes {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    z-index: 9;

    input#password {
      width: auto;
    }

    .alert {
      width: 100%;
      margin-bottom: 0;
    }
  }

  input#slug {
    display: inline;
    width: auto;
  }

  .btn.change-password,
  .btn.change-role{
    font-weight: bold;
    color: black !important;
    border: none !important;
    background: transparent !important;
    vertical-align: middle;
    i {
      color: #f1a444;
      vertical-align: middle;
      margin-top: -0.5rem;
    }
  }

  .btn.change-role {
    i {
      margin-top: -0.2rem;
    }
  }

  a.delete-account {
    display: block;
    margin: 2rem auto;
    color: black !important;
    font-weight: bold;
    vertical-align: middle;

    svg {
      margin-right: 0.3rem;
      vertical-align: middle;
    }
  }

  .fast-signup {
    .profile-photo {
      margin: 0 auto;
      img {
        display: block;
        margin-bottom: 1rem;
        max-width: 200px;
        height: auto;
      }

      .btn {
        margin: 0 auto;
      }
    }
  }

  .profile-header {
    .other-photos {
      .row {
        margin: 0 !important;
      }

      @include media-breakpoint-down(md) {
        width: 300px;
      }
    }
  }

  .other-photos {
    position: relative;
    margin-top: -7rem;
    background: white;

    &.no-photos {
      margin-top: 1rem;
      background: transparent;
    }

    .photo {
      position: relative;
      width: 25%;
      height: 140px;
      padding: 0;
      margin: 0;
      overflow: hidden;
      vertical-align: top;

      img {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        height: 100%;
        width: auto;
      }

      @include media-breakpoint-down(md) {
        height: 120px;
      }
    }

    .buttons {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      margin-top: -1rem;

      @include media-breakpoint-down(sm) {
        position: relative;
        left: unset;
        top: unset;
        transform: unset;
        margin: 0 auto;
      }
    }
    .btn-instagram {
      padding: 0.1rem 0.7rem 0.1rem 0.1rem;
      color: #903e9f !important;
      font-weight: bold;
      border: 1px solid #f0f0f0;
      background-color: white !important;

      &.connect {
        margin-bottom: 2.5rem;

        @include media-breakpoint-down(md) {
          margin-bottom: -0.5rem;
        }

        @include media-breakpoint-down(sm) {
          margin-bottom: -1rem;
        }
      }
    }

    .btn-delete-instagram {
      height: 100%;
      padding: 1.2rem;
      text-align: center;
      border-color: #903e9f;
      background-color: #903e9f !important;
      color: white;

      i {
        margin-right: 0 !important;
      }
    }

    .source {

    }

    .white-block {
      border: 1px solid #f0f0f0;
      background: white;

      @include media-breakpoint-down(sm) {
        width: 100%;
      }
    }

    @include media-breakpoint-down(md) {
      .photo {
        position: relative;
        width: 75px;
        height: 75px;
      }

      .insta-score {
        padding: 0.6rem 0.1rem;

        span {

        }
        .percent {
          font-size: 0.7rem;
        }
      }

      .btn-instagram:not(.connect) {
        padding: 0.7rem 0.7rem 0.7rem 0.1rem;

        img {
          width: 40px;
          height: auto;
        }
      }

      .btn-delete.instagram {
        padding: 0.53rem;
      }
    }

    @include media-breakpoint-down(sm) {
      width: auto;
      margin-top: 3rem;

      .insta-score {
        padding: 0.65rem;
      }
    }
  }

  .btn-posts {
    padding: 0.7rem;
    color: #3c5a99 !important;
    font-weight: bold;
    border: 1px solid #f0f0f0;
    background-color: white !important;

    img {
      margin-right: 0.5rem;
    }
  }

  #fbActivitiesModal {
    .btn-posts {
      padding: 1rem;
      color: white !important;;
      font-weight: bold;
      border: 1px solid #f0f0f0;
      background-color: #3C5A99 !important;

      img {
        padding-right: 0.5rem;
        vertical-align: top;
      }

      &.connect-private {
        color: #3c5a99 !important;
        border: 1px solid #3c5a99;
        background-color: white !important;
      }
    }
  }

  .btn-delete-posts {
    padding: 1.2rem;
    color: #3c5a99 !important;
    font-weight: bold;
    border: 1px solid #f0f0f0;
    background-color: white !important;
    vertical-align: middle;

    i {

    }

    &:hover {
      border-color: #3c5a99;
    }
  }

  .btn-analyze-posts {
    padding: 1.2rem;
    color: #15c7a8 !important;
    font-weight: bold;
    border: 1px solid #f0f0f0;
    background-color: white !important;
    vertical-align: middle;

    i {

    }

    &:hover {
      border-color: #15c7a8;
    }
  }

  // colors customized
  $primary-color-blue: #30bae7;
  $primary-color-green: #15c7a8;
  $primary-color-orange: #eb7d4b;
  $primary-color-red: #D74D4C;
  $primary-color-span: #3c4761;

  .fb-score,
  .insta-score {
    color: white;
    text-align: center;
    padding: 0.65rem;
    background: #3c5a99;
    vertical-align: middle;

    &.low {
      background: $primary-color-red;
    }

    &.medium {
      background: $primary-color-orange;
    }

    &.high {
      background: $primary-color-green;
    }

    span {
      display: block;
      font-size: 0.6rem;
      margin: 0.2rem auto;
      line-height: 0.7rem;
    }

    .percent {
      font-size: 1rem;
      font-weight: bold;
    }
  }

  .insta-score {
    span {
      margin: 0.1rem auto;
    }
  }

  #analyzePostsModal,
  #analyzePhotosModal {
    svg {
      display: block;
      margin: 0 auto;
      margin-bottom: 1rem;
      width: 100px;
      height: auto;
    }
  }

  // VARS
  $circle-width: 0.09em;
  $circle-width-hover: 0.07em;

  // colors default
  $primary-color: #000000; // czarny
  $secondary-color: #dfe8ed; //szary bcg
  $bg-color: #ffffff; //srodkowy bezowy

  // CIRCLE
  // classes 2 extend
  .rect-auto{
    clip: rect(auto, auto, auto, auto);
  }

  .pie {
    position: absolute;
    border: $circle-width solid $primary-color;
    width: 1 - (2 * $circle-width);
    height: 1 - (2 * $circle-width);
    clip: rect(0em, 0.5em, 1em, 0em);
    border-radius: 50%;
    transform: rotate(0deg);
  }

  .pie-fill {
    transform: rotate(180deg);
  }

  .c100 {

    *, *:before, *:after {
      box-sizing: content-box;
    }

    position: relative;
    font-size: 160px;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    margin: 1rem auto;
    background-color: $secondary-color;

    // 	// center circle to its parent
    // 	&.center{
    // 		float: none;
    // 		margin: 0 auto;
    // 	}

    // 	&.small{
    // 		font-size: 80px;
    // 	}

    // centered value inside circle
    > span {
      position: absolute;
      z-index: 1;
      left: 0;
      top: 0;
      width: 5em;
      line-height: 5em;
      font-size: 0.2em;
      color: $primary-color-span;
      display: block;
      text-align: center;
      white-space: nowrap;
      transition-property: all;
      transition-duration: 0.2s;
      transition-timing-function: ease-out;
    }

    // background inside the circle
    &:after{
      position: absolute;
      top: $circle-width;
      left: $circle-width;
      display: block;
      content: " ";
      border-radius: 50%;
      background-color: $bg-color;
      width: 1 - (2 * $circle-width);
      height: 1 - (2 * $circle-width);
      transition-property: all;
      transition-duration: 0.2s;
      transition-timing-function: ease-in;

    }

    // the slice (mask)
    .slice {
      position: absolute;
      width: 1em;
      height: 1em;
      clip: rect(0em, 1em, 1em, 0.5em);
    }

    // circle to show the status
    .bar {
      @extend .pie;
    }


    // loop to create all needed elements automatically
    @for $j from 51 through 100 {

      &.p#{$j} .slice {
        @extend .rect-auto;
      }

      &.p#{$j} .bar:after{
        @extend .pie-fill;
      }

      &.p#{$j} .fill{
        @extend .pie;
        @extend .pie-fill;
      }

    }

    // loop to rotate all 100 circles
    @for $j from 1 through 100 {
      &.p#{$j} .bar {
        transform: rotate((360/100*$j) + deg);
        /*-webkit-animation: rotation#{$j} 2s ease-in forwards;
        -moz-animation: rotation#{$j} 2s ease-in forwards;
        animation: rotation#{$j} 2s ease-in forwards;

        @keyframes rotation#{$j} {
          0%{
            -webkit-transform: rotate((360/100-45*$j) + deg);
            transform: rotate((360/100-45*$j) + deg);
          }
          100%{
            -webkit-transform: rotate((360/100*$j) + deg);
            transform: rotate((360/100*$j) + deg);
          }
        }*/
      }
    }

    // hover styles
    &:hover{

      cursor: default;

      > span {
        width: 3.33em;
        line-height: 3.33em;
        font-size: 0.3em;
        color: $primary-color-span;
      }

      &:after{
        top: $circle-width-hover;
        left: $circle-width-hover;
        width: 1 - (2 * $circle-width-hover);
        height: 1 - (2 * $circle-width-hover);
      }

    }

    // blue
    &.blue{

      .bar, .fill { border-color: $primary-color-blue !important;}

      &:hover{
        > span { color: $primary-color-span;}
      }

    }


    // pink skin
    &.low{

      .bar, .fill { border-color: $primary-color-red !important;}

      &:hover{
        > span { color: $primary-color-span;}
      }

    }


    // green skin
    &.high{

      .bar, .fill { border-color: $primary-color-green !important;}

      &:hover{
        > span { color: $primary-color-span;}
      }

    }


    // orange skin
    &.medium{

      .bar, .fill { border-color: $primary-color-orange !important;}

      &:hover{
        > span { color: $primary-color-span;}
      }

    }
  }

  .btn-instagram {
    color: white !important;
  }

  .social-activities {
    #photos {
      img {
        width: 100%;
        height: auto;
      }
    }

    #posts {
      .btn-facebook {
        color: white;
        background-color: #3c5a99;
        vertical-align: middle;

        img {
          margin-top: -0.2rem;
          margin-right: 0.5rem;
          vertical-align: middle;
        }
      }
    }
  }

  .md-stepper-horizontal {
    display: table;
    width: 100%;
    margin: 0 auto;
    .md-step {
      display: table-cell;
      position: relative;
      padding: 24px;
      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
      }
      &:active {
        background-color: rgba(0, 0, 0, 0.04);
        border-radius: 15% / 75%;
      }
      &:first-child:active {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
      &:last-child:active {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      &:hover .md-step-circle {
        background-color: #757575;
      }
      &:first-child .md-step-bar-left, &:last-child .md-step-bar-right {
        display: none;
      }
      .md-step-circle {
        width: 30px;
        height: 30px;
        margin: 0 auto;
        background-color: #999999;
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
      }

      @include media-breakpoint-down(sm) {
        display: block;

        .md-step-bar-left,
        .md-step-bar-right {
          display: none;
        }
      }
    }
    &.green .md-step.active .md-step-circle {
      background-color: #00AE4D;
    }
    &.orange .md-step.active .md-step-circle {
      background-color: #F96302;
    }
    .md-step {
      &.active .md-step-circle {
        background-color: rgb(33, 150, 243);
      }
      &.done .md-step-circle {
        &:before {
          font-family: 'FontAwesome';
          font-weight: 100;
          content: "\f00c";
        }
        * {
          display: none;
        }
      }
      &.editable {
        .md-step-circle {
          * {
            display: none;
          }
          -moz-transform: scaleX(-1);
          -o-transform: scaleX(-1);
          -webkit-transform: scaleX(-1);
          transform: scaleX(-1);
          &:before {
            font-family: 'FontAwesome';
            font-weight: 100;
            content: "\f040";
          }
        }
      }
      .md-step-title {
        margin-top: 16px;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        color: rgba(0, 0, 0, 0.26);
      }
      .md-step-optional {
        text-align: center;
        color: rgba(0, 0, 0, 0.26);
      }
      &.active {
        .md-step-title {
          font-weight: 600;
          color: rgba(0, 0, 0, 0.87);
        }
        &.done .md-step-title, &.editable .md-step-title {
          font-weight: 600;
        }
      }
      .md-step-optional {
        font-size: 12px;
      }
      &.active .md-step-optional {
        color: rgba(0, 0, 0, 0.54);
      }
      .md-step-bar-left {
        position: absolute;
        top: 36px;
        height: 1px;
        border-top: 1px solid #DDDDDD;
      }
      .md-step-bar-right {
        position: absolute;
        top: 36px;
        height: 1px;
        border-top: 1px solid #DDDDDD;
        right: 0;
        left: 50%;
        margin-left: 20px;
      }
      .md-step-bar-left {
        left: 0;
        right: 50%;
        margin-right: 20px;
      }
    }
  }
</style>
